
import { type RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [{
    path: 'login',
    name: 'login',
    component: () => import('./views/login/LoginView.vue')
}, {
    path: 'forgot-password',
    name: 'forgot-password',
    component: () => import('./views/forgot-password/ForgotPasswordView.vue')
}, {
    path: 'reset-password',
    name: 'reset-password',
    component: () => import('./views/reset-password/ResetPasswordView.vue')
}];